// ==============API CREATION OF QUICK_RESPONSE ================
export const QUICK_RESPONSE_CREATE_REQUEST = "quick response creation request";
export const QUICK_RESPONSE_CREATE_SUCCESS = "quick response creation success";
export const QUICK_RESPONSE_CREATE_FAILURE = "quick response creation failure";
// ==============API READ OF QUICK_RESPONSE ================
export const QUICK_RESPONSE_READ_REQUEST = "quick response read request";
export const QUICK_RESPONSE_READ_SUCCESS = "quick response read success";
export const QUICK_RESPONSE_READ_FAILURE = "quick response read failure";
// ==============API UPDATE OF QUICK_RESPONSE ================
export const QUICK_RESPONSE_UPDATE_REQUEST = "quick response update request";
export const QUICK_RESPONSE_UPDATE_SUCCESS = "quick response update success";
export const QUICK_RESPONSE_UPDATE_FAILURE = "quick response update failure";
// ==============API DELETION OF QUICK_RESPONSE ================
export const QUICK_RESPONSE_DELETE_REQUEST = "quick response delete request";
export const QUICK_RESPONSE_DELETE_SUCCESS = "quick response delete success";
export const QUICK_RESPONSE_DELETE_FAILURE = "quick response delete failure";

// ==============API create OF QUICK_RESPONSE ================
export function quickResponseCreateRequest(isFetching) {
  return {
    type: QUICK_RESPONSE_CREATE_REQUEST,
    isFetching: isFetching,
  };
}

export function quickResponseCreateSuccess(quickResponse) {
  return {
    type: QUICK_RESPONSE_CREATE_SUCCESS,
    quickResponse: quickResponse,
  };
}

export function quickResponseCreateFailure(error, response) {
  return {
    type: QUICK_RESPONSE_CREATE_FAILURE,
    error: error,
    response: response,
  };
}

// ==============API read OF QUICK_RESPONSE ================
export function quickResponseReadRequest(isFetching) {
  return {
    type: QUICK_RESPONSE_READ_REQUEST,
    isFetching: isFetching,
  };
}

export function quickResponseReadSuccess(quickResponses) {
  return {
    type: QUICK_RESPONSE_READ_SUCCESS,
    quickResponses: quickResponses,
  };
}

export function quickResponseReadFailure(error, response) {
  return {
    type: QUICK_RESPONSE_READ_FAILURE,
    error: error,
    response: response,
  };
}

// ==============API UPDATE OF QUICK_RESPONSE ================
export function quickResponseUpdateRequest(isFetching) {
  return {
    type: QUICK_RESPONSE_UPDATE_REQUEST,
    isFetching: isFetching,
  };
}

export function quickResponseUpdateSuccess(quickResponse, id) {
  return {
    type: QUICK_RESPONSE_UPDATE_SUCCESS,
    quickResponse: quickResponse,
    id: id,
  };
}

export function quickResponseUpdateFailure(error, response) {
  return {
    type: QUICK_RESPONSE_UPDATE_FAILURE,
    error: error,
    response: response,
  };
}

// ==============API DELETION OF QUICK_RESPONSE ================
export function quickResponseDeleteRequest(isFetching) {
  return {
    type: QUICK_RESPONSE_DELETE_REQUEST,
    isFetching: isFetching,
  };
}

export function quickResponseDeleteSuccess(id) {
  return {
    type: QUICK_RESPONSE_DELETE_SUCCESS,
    id,
  };
}

export function quickResponseDeleteFailure(error, response) {
  return {
    type: QUICK_RESPONSE_DELETE_FAILURE,
    error: error,
    response: response,
  };
}



// WEBPACK FOOTER //
// ./src/model/QuickResponse/actions.js